import React from 'react';
import LaunchpadPage from '../../Pages/LaunchpadPage';

const LaunchpadContainer = () => {
  return <LaunchpadPage />;
};

export default LaunchpadContainer;
